import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function ControlledExpansionPanels() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const settings = [
     {
      link: 'https://youtu.be/tOnuXFEUnqo',
      text: 'https://youtu.be/tOnuXFEUnqo',
      lbl: 'Watch the "GET STARTED" video'
    },
    {
      link: 'https://vybrnt.com/activecampaign-blog/',
      text: 'https://vybrnt.com/activecampaign-blog/',
      lbl: 'Access additional VYBRNT SMS training materials and blogs'
    },
    {
      link: 'https://calendly.com/tim-vybrnt/30min',
      text: 'https://calendly.com/tim-vybrnt/30min',
      lbl: 'Book a training call'
    },
  ]

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <ExpansionPanel
      expanded={expanded === "panel1"}
      onChange={handleChange("panel1")}
    >
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography className={classes.heading}>
          <span className="mb-10"><b>Education Center</b></span>
        </Typography>
        <Typography className={classes.secondaryHeading}>
          How to use platform
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails style={{ display: "block" }}>
      <ul style={{ marginLeft: "40px" }}>
          {
            settings?.map((setting, i) => (<li>
              <Typography className={classes.heading}>
                {setting.lbl}: <a href={setting.link} >{ setting.text }</a>
              </Typography>
            </li>))
          }

        </ul>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}
